import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@mui/material';
import { PoolTypography } from '@synergy/components';

import { InternalNotes } from '../../../../../../common/components/internal-notes/internal-notes';
import { NoteType } from '../../../../../../common/models/enums/note-type';
import { productDetailSelector } from '../store/product-detail-overview-selectors';
import { useAppSelector } from '../../../../../../store/use-appstate-selector';

export const ProductDetailOverviewSectionNotes = (): ReactElement => {
    const product = useAppSelector(productDetailSelector);

    return (
        <>
            <PoolTypography
                sx={{ mt: 4 }}
                styleType="sectionTitle"
                id="app.contactsAndOrganizations.detail.internalNotes.title"
            />
            <Grid container={true}>
                <Grid item={true} xs={12}>
                    <FormattedMessage id="app.contactsAndOrganizations.detail.internalNotes.text" />
                    {product?.id && <InternalNotes noteType={NoteType.Products} entityId={product.id} />}
                </Grid>
            </Grid>
        </>
    );
};
